import React from 'react';
import {withRouter} from 'react-router-dom';
import axios from 'axios';
import Properties from "../const/Properties";
import CustomTable from "../thema/tema1/component/CustomTable";

const active = {Home: "active"};
const bankalar = {
    0: "BELİRLENMEDİ",
    1: "ZİRAAT",
    2: "İŞ BANKASI"
};
const urunler = {
    0: "ÜRÜN SEÇ",
    1: "GEMİ ÜCRETİ",
    2: "UÇAK ÜCRETİ",
    3: "ETS",
    4: "EK SÜRÜCÜ",
    5: "YANICI",
    6: "SİGORTA",
    7: "YOL GEÇİŞ ÜCRETİ",
    8: "ENS",
    9: "BAF",
    10: "ŞOFÖR ÜCRETİ",
    11: "XRAY",
    12: "REZERVASYON ÜCRETİ",
    13: "LİMAN ÜCRETİ",
    14: "FORKLİFT ÜCRETİ",
};
class FaturaPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tasimaId: props.tasimaId,
            pageCount: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            plaka: "",
            urunId: 0,
            firmaId: 0,
            muhasebefirmalar: [],
            faturaNumarasi: "",
            tutar: 0,
            id: 0,
            duzenleId: 0,
            silModal: 'none',
            title: [ "FİRMA", "ÜRÜN", "BANKA", "NO","TUTAR", "İŞLEMLER"],
            showDuzenle: 0,
            gidecegiUlke: 0,
            duzenle: false,
            error: 0
        };
        this.muhasebefirmaDoldur();
        this.getPlaka(props.tasimaId);
        this.handlePageClick({selected:0,tasimaId:props.tasimaId});
        this.getTotalRow();
    }
    onChange = e => {
        this.setState({[e.target.name]: e.target.value})
    }
    getPlaka = (e) => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tasima/get/'+e,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                console.log(res.data);
                this.setState({ plaka: res.data.cekiciPlaka });
            })
    }
    muhasebefirmaDoldur = () => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/muhasebefirma/getAll',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let firmalar = [<option value={0} key={0}>FİRMA SEÇ</option>,res.data.map((item) =>
                    <option value={item.id}>{item.firmaAdi}</option>)]
                this.setState({ firmalar: firmalar });
                let muhasebefirmalar = [];
                for (let i = 0; i < res.data.length; i++) {
                    muhasebefirmalar[res.data[i].id] = res.data[i].firmaAdi;
                }
                this.setState({muhasebefirmalar: muhasebefirmalar});
            })
    }
    cikis = e => {
        window.location = '/gider';
    }
    sifirla = e => {
        this.setState({showDuzenle: 0});
        this.setState({id:0});
        this.setState({firmaId: 0});
        this.setState({urunId: 0});
        this.setState({bankaId:0});
        this.setState({faturaNumarasi: ""});
        this.setState({tutar: 0});
    }
    save = e => {
        let status = true;
        if (status) {
            if(this.state.showDuzenle === 1)
            {
                axios({
                    method: 'post',
                    url: Properties.baseUrl + '/fatura/save',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    },
                    data: {
                        //plaka: this.state.plaka ? this.state.plaka.toUpperCase().replace(/\s/g, '') : '',
                        id: this.state.id,
                        firmaId: this.state.firmaId ? this.state.firmaId : 0,
                        tasimaId: this.state.tasimaId ? this.state.tasimaId : 0,
                        urunId: this.state.urunId ? this.state.urunId : 0,
                        bankaId: this.state.bankaId ? this.state.bankaId : 0,
                        faturaNumarasi: this.state.faturaNumarasi ? this.state.faturaNumarasi : "",
                        tutar: this.state.tutar ? this.state.tutar : 0,
                    }
                })
                    .then(res => {
                        window.successful((this.state.showDuzenle ? "Fatura Güncellendi." : "Fatura Kaydedildi"));
                        this.handlePageClick({selected:0,tasimaId:this.state.tasimaId});
                        this.getTotalRow();
                        this.setState({showDuzenle: 0});
                        //this.cikis();
                    }).catch(res => {
                });
            }
            else
            {
                axios({
                    method: 'post',
                    url: Properties.baseUrl + '/fatura/save',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    },
                    data: {
                        //plaka: this.state.plaka ? this.state.plaka.toUpperCase().replace(/\s/g, '') : '',
                        firmaId: this.state.firmaId ? this.state.firmaId : 0,
                        tasimaId: this.state.tasimaId ? this.state.tasimaId : 0,
                        urunId: this.state.urunId ? this.state.urunId : 0,
                        bankaId: this.state.bankaId ? this.state.bankaId : 0,
                        faturaNumarasi: this.state.faturaNumarasi ? this.state.faturaNumarasi : "",
                        tutar: this.state.tutar ? this.state.tutar : 0,
                    }
                })
                    .then(res => {
                        window.successful((this.state.showDuzenle ? "Fatura Güncellendi." : "Fatura Kaydedildi"));
                        this.handlePageClick({selected:0,tasimaId:this.state.tasimaId});
                        this.getTotalRow();
                        //this.cikis();
                    }).catch(res => {
                });
            }

        }
    }
    getTotalRow = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/fatura/toplam/',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                this.setState({totalRow:res.data});
                this.setState({pageCount:res.data/10});
            });
    }
    setSil = (e) => {
        console.log(e);
        axios({
            method: 'get',
            url: Properties.baseUrl+'/fatura/delete/' + e,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                window.successful("Fatura Silindi.");
                this.handlePageClick({selected:0,tasimaId:this.state.tasimaId});
                this.getTotalRow();
            });
    }
    setDuzenle = (e) => {
        this.setState({showDuzenle: 1});
        this.setState({id: e.id});
        this.setState({firmaId: e.firmaId});
        this.setState({urunId: e.urunId});
        this.setState({bankaId: e.bankaId});
        this.setState({faturaNumarasi: e.faturaNumarasi});
        this.setState({tutar: e.tutar});
    }
    handlePageClick=e=>{
        this.setState({ startRow: (e.selected*10)+1});
        this.setState({ endRow:((e.selected+1)*10)});
        axios({
            method: 'get',
            url: Properties.baseUrl+'/fatura/sayfaliGetir/'+e.selected+'/'+this.state.tasimaId,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.tasimaId = eleman.tasimaId;
                    elemanIc.firmaId = eleman.firmaId;
                    elemanIc.urunId = eleman.urunId;
                    elemanIc.bankaId = eleman.bankaId;
                    elemanIc.faturaNumarasi = eleman.faturaNumarasi;
                    elemanIc.tutar = eleman.tutar;
                    getData.push(eleman);
                });
                this.setState({tasimalar:getData});
                let content = getData.map((item) =>
                    (<tr>
                        <td>{this.state.muhasebefirmalar[item.firmaId]}</td>
                        <td>{urunler[item.urunId]}</td>
                        <td>{bankalar[item.bankaId]}</td>
                        <td>{item.faturaNumarasi}</td>
                        <td>{item.tutar}</td>
                        <td>
                            <div className="row">
                                <div className="col-4">
                                    <button type="button"
                                            onClick={e => this.setDuzenle(item)}
                                            className="btn btn-block btn-outline-info">DÜZENLE
                                    </button>
                                </div>
                                <div className="col-3">
                                    <button type="button"
                                            className="btn btn-block btn-outline-primary"
                                            onClick={e => this.setSil(item.id)}>SİL
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>));
                this.setState({content: content});
            });
    }
    render() {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <form>

                    <div className="card-body">
                        <div className="col-12">
                            <label htmlFor="exampleInputEmail1">Çekici Plaka</label>
                            <input disabled type="text" className="form-control" name="plaka"
                                   onChange={this.onChange} value={this.state.plaka}
                                   placeholder="Plaka"/>
                        </div>
                        <div className="col-12">
                            <label>Ürün Adı</label>
                            <select name="urunId" className="form-control select2"
                                    onChange={this.onChange} value={this.state.urunId}>
                                {Object.entries(urunler).map(([key, value]) => (
                                    <option key={key} value={key}>
                                        {value}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-12">
                            <label>Firma Adı</label>
                            <select name="firmaId" className="form-control select2"
                                    onChange={this.onChange} value={this.state.firmaId}>
                                {this.state.firmalar}
                            </select>
                        </div>
                        <div className="col-12">
                            <label>Banka Adı</label>
                            <select name="bankaId" className="form-control select2"
                                    onChange={this.onChange} value={this.state.bankaId}>
                                {Object.entries(bankalar).map(([key, value]) => (
                                    <option key={key} value={key}>
                                        {value}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-12">
                            <label htmlFor="exampleInputEmail1">Fatura Numarası</label>
                            <input type="text" className="form-control" name="faturaNumarasi"
                                   onChange={this.onChange} value={this.state.faturaNumarasi}
                                   placeholder="Fatura Numarası"/>
                        </div>
                        <div className="col-12">
                            <label htmlFor="exampleInputEmail1">Tutar</label>
                            <input type="text" className="form-control" name="tutar"
                                   onChange={this.onChange} value={this.state.tutar}
                                   placeholder="Tutar"/>
                        </div>
                        <div className=" row">
                            <div className="col-6">
                                <button type="button"
                                        onClick={this.save}
                                        className="btn btn-block btn-primary">Kaydet
                                </button>
                            </div>
                            <div className="col-3">
                                <button type="button" onClick={e => this.cikis(e)}
                                        className="btn btn-block btn-outline-info">Çıkış
                                </button>
                            </div>
                            <div className="col-3">
                                <button type="button" onClick={e => this.sifirla()}
                                        className="btn btn-block btn-outline-info">Sıfırla
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <CustomTable state={this.state} getTotalRow={this.getTotalRow}
                                     handlePageClick={this.handlePageClick}></CustomTable>
                    </div>
                </form>

            </div>);
    }
}


export default withRouter(FaturaPopup);
